// import dailyLiving from '@/views/pages/operations/dailyLiving/index.vue';
// import Feedback from '@/views/pages/operations/feedback/index.vue';
// import Roles from '@/views/pages/operations/roles/index.vue';
// import Users from '@/views/pages/operations/users/index.vue';
// import Privilege from '@/views/pages/operations/privilege/index.vue';
// import CDHDataSetPermission from '@/views/pages/operations/cdhDataSetPermission/index.vue';

const dailyLiving = () => import('@/views/pages/operations/dailyLiving/index.vue');
const Feedback = () => import('@/views/pages/operations/feedback/index.vue');
const Roles = () => import('@/views/pages/operations/roles/index.vue');
const Users = () => import('@/views/pages/operations/users/index.vue');
const Privilege = () => import('@/views/pages/operations/privilege/index.vue');
const CDHDataSetPermission = () => import('@/views/pages/operations/cdhDataSetPermission/index.vue');
const Notice = () => import('@/views/pages/operations/notice/index.vue');

const OperationsRouteList = [
  {
    path: 'user',
    component: Users,
    name: '/user',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Users',
      mid: '0a7d-f8b2',
    },
  },
  {
    path: 'role',
    component: Roles,
    name: '/role',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Roles',
      mid: 'c5e1-9d46',
    },
  },
  {
    path: 'privileges',
    component: Privilege,
    name: '/privileges',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Privileges',
      mid: '8f2a-4b70',
    },
  },
  {
    path: 'feedbackList',
    component: Feedback,
    name: '/feedbackList',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Feedback List',
      mid: 'd9b6-1c8e',
    },
  },
  {
    path: 'dailyDashboard',
    component: dailyLiving,
    name: '/dailyDashboard',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Daily Dashboard',
      mid: '7a0d-e5f3',
    },
  },
  {
    path: 'dataAssetPermission',
    component: CDHDataSetPermission,
    name: '/dataAssetPermission',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Data Asset Permission',
      mid: '2b4c-9a61',
    },
  },
  {
    path: 'notice',
    component: Notice,
    name: '/notice',
    meta: {
      ownType: 'Operations',
      lableTitle: 'Data Asset Permission',
      mid: 'e6f8-3d05',
    },
  },
];

export default OperationsRouteList;
